/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum statusEnum {
    NEW = 'new',
    SENT = 'sent',
    ACCEPTED = 'accepted',
    DECLINED = 'declined',
    CANCELLED = 'cancelled',
    EXPIRED = 'expired',
    NEW_OR_SENT = 'new_or_sent',
}